import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import store, { loanActions } from '@apply/adminStore';
import Dialog from '@material-ui/core/Dialog';
import { InformModal, BfiNumber, LoanNumber, BfiCustomStore } from '../../common/SharedComponents';
import { ListApi, LoanApi } from '@apply/api';
import { ConfirmModal } from '@apply/ui';
import { applicationInsights } from '../../ApplicationInsights';
import { RefreshEvents } from '../../common/SharedEvents';
import DateBox from 'devextreme-react/date-box';
import { NumericFormat } from 'react-number-format';
import { BrokerSelect, BClientOrEntitySelectorType, BClientOrEntitySelector, LoanTermFields } from '../common/LoanComponents';
import { LoanType, LoanStatusType } from '../common/LoanConstants';
import { LoanGradeTypeOptions } from '@apply/constants';
import { InsuranceGrid } from '../insurance/common/InsuranceComponents';
import { setInsurancesForLoanType } from '../insurance/common/InsuranceFunctions';
import { LoadPanel } from 'devextreme-react/load-panel';
import { Tooltip } from 'devextreme-react/tooltip';
import { getStatusTypeName, findMatchingTermOptionKey } from '../common/LoanFunctions';
import { addMonths, handleAdminError, handleAdminSuccess, monthDiff } from '../../common/SharedFunctions';
import { LoanChangeReasonModal } from './LoanChangeReasonModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { MonthTypeOptions } from '../common/constants/MonthTypeOptions';

const EditMasterNoteModal = () => {
    const { isOpen, loanId = 0, showInsurance = false } = useSelector((state) => state.loan.editMasterNoteModal);

    const emptyInsuranceGroup = {
        allGood: true,
        notes: null,
        insurances: [],
    };

    const styles = {
        sectionHeader: { margin: '10px 0' },
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            marginRight: '20px',
            textAlign: 'right',
            padding: '10px 10px',
        },
        formColumn: { paddingBottom: '5px', paddingRight: '5px' },
        leftLabel: { paddingTop: '10px', whiteSpace: 'nowrap' },
        searchResult: { lineHeight: '25px' },
        headerRight: {
            width: '100px',
            position: 'absolute',
            right: '20px',
            paddingTop: '15px',
        },
        iconContainer: { paddingLeft: '0', paddingRight: '0' },
        mathOperation: { padding: '32px 10px 10px', maxWidth: '20px' },
        warning: {
            padding: '10px',
            color: 'darkred',
            width: '100%',
            textAlign: 'center',
            fontSize: 'smaller',
        },
    };

    const { dispatch } = store;
    const loanApi = new LoanApi.LoanApi(applicationInsights);
    const refreshEvents = new RefreshEvents();
    const listApi = new ListApi.ListApi(applicationInsights);
    const historyStore = new BfiCustomStore();

    const [employees, set_employees] = useState([]);
    const [brokerFeeTypes, set_brokerFeeTypes] = useState([]);
    const [interestTypes, set_interestTypes] = useState([]);
    const [interestpaymentDueTypes, set_interestpaymentDueTypes] = useState([]);

    //Loan Fields
    const [currentLoanId, set_currentLoanId] = useState(0);
    const [loan, set_loan] = useState(null);

    const [statusId, set_statusId] = useState(0);
    const [approvalDate, set_approvalDate] = useState(null);
    const [bfiNumber, set_bfiNumber] = useState('');
    const [loanNumber, set_loanNumber] = useState('');
    const [noteDate, set_noteDate] = useState(null);
    const [commitment, set_commitment] = useState('');
    const [selectedTermKey, set_selectedTermKey] = useState('');
    const [initialTermMonths, set_initialTermMonths] = useState(null);
    const [contractualExtension1Months, set_contractualExtension1Months] = useState(null);
    const [contractualExtension2Months, set_contractualExtension2Months] = useState(null);
    const [maturityDate, set_maturityDate] = useState(null);
    const [plannedClosingDate, set_plannedClosingDate] = useState(null);
    const [interestTypeId, set_interestTypeId] = useState(0);
    const [interestRate, set_interestRate] = useState('');
    const [reserveRate, set_reserveRate] = useState('');
    const [loanGradeType, set_loanGradeType] = useState('');
    const [brokerFee, set_brokerFee] = useState('');
    const [pointOfContactId, set_pointOfContactId] = useState('');
    const [bClientOrEntity, set_bClientOrEntity] = useState(BClientOrEntitySelectorType.Entity);
    const [borrowerEntityId, set_borrowerEntityId] = useState('');
    const [brokerAgreementId, set_brokerAgreementId] = useState('');
    const [brokerAgreementLocked, set_brokerAgreementLocked] = useState(false);
    const [brokerId, set_brokerId] = useState('');
    const [brokerFeeTypeId, set_brokerFeeTypeId] = useState('');
    const [brokerFeeName, set_brokerFeeName] = useState('');
    const [brokerFootnote, set_brokerFootnote] = useState('');
    const [sbaGuarantyPercent, set_sbaGuarantyPercent] = useState('');
    const [sbaUpfrontFee, set_sbaUpfrontFee] = useState('');
    const [borrowerCharge, set_borrowerCharge] = useState('');
    const [recurringSbaFeePercent, set_recurringSbaFeePercent] = useState('');
    const [interestPaymentDueTypeId, set_interestPaymentDueTypeId] = useState('');
    const [interestPaymentStartingMonth, set_interestPaymentStartingMonth] = useState('');
    const [dueDate1, set_dueDate1] = useState('');
    const [dueDate2, set_dueDate2] = useState('');
    const [dueDate3, set_dueDate3] = useState('');
    const [dueDate4, set_dueDate4] = useState('');
    const [insuranceGroup, set_insuranceGroup] = useState(emptyInsuranceGroup);
    const [isBfiNumberValid, set_isBfiNumberValid] = useState(true);
    const [isLoanNumberValid, set_isLoanNumberValid] = useState(true);
    const [checkNumbers, set_checkNumbers] = useState('');
    const [repaidDate, set_repaidDate] = useState('');
    const [repaidReason, set_repaidReason] = useState('');

    //Bfi NUmber Check
    const [confirmNumbersModalText, set_confirmNumbersModalText] = useState(false);
    const [confirmNumbersModalOpen, set_confirmNumbersModalOpen] = useState(false);

    //Move to Outstanding
    const [confirmMoveToOutstandingModalText, set_confirmMoveToOutstandingModalText] = useState(false);
    const [confirmMoveToOutstandingModalOpen, set_confirmMoveToOutstandingModalOpen] = useState(false);

    //Inform Modal
    const [informModalOpen, set_informModalOpen] = useState(false);
    const [informModalMessage, set_informModalMessage] = useState('');

    //Dialogs
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');

    //ToolTips
    const [instructionsToolTipVisible, set_instructionsToolTipVisible] = useState(false);

    //Changes Modal
    const [changesModalOpen, set_changesModalOpen] = useState(false);

    //Maturity Date Warnings
    const [maturityDateWarning, set_maturityDateWarning] = useState(false);
    const [maturityDateWarningText, set_maturityDateWarningText] = useState('');
    const [confirmMaturityDateModalText, set_confirmMaturityDateModalText] = useState('');
    const [confirmMaturityDateModalOpen, set_confirmMaturityDateModalOpen] = useState(false);

    const getMonthById = (id) => MonthTypeOptions.find((m) => m.id === id);

    const getMonthBySortOrder = (sortOrder) => MonthTypeOptions.find((m) => m.sortOrder === sortOrder);

    function buildPaymentSchedule(paymentType, startMonthId) {
        const schedule = [];

        const startMonthObj = getMonthById(startMonthId) || MonthTypeOptions[1]; // January fallback
        const startSortOrder = startMonthObj.sortOrder;

        const step = paymentType === 0 ? 1 : paymentType === 1 ? 3 : paymentType === 2 ? 6 : 1;

        const count = paymentType === 0 ? 12 : paymentType === 1 ? 4 : paymentType === 2 ? 2 : 0;

        for (let i = 0; i < count; i++) {
            const nextSortOrder = ((startSortOrder - 1 + i * step) % 12) + 1;
            const monthObj = getMonthBySortOrder(nextSortOrder) || MonthTypeOptions[1]; // safe fallback

            schedule.push({
                monthId: monthObj.id,
                scheduleDate: '01/' + monthObj.id,
                label: `${monthObj.name} 1st`,
            });
        }

        return schedule;
    }

    const schedule = buildPaymentSchedule(interestPaymentDueTypeId, interestPaymentStartingMonth);

    const handleClose = () =>
        dispatch(
            loanActions.setEditMasterNoteModal({
                editMasterNoteModal: { isOpen: false },
            })
        );

    const saveStages = {
        vvalidateSbaFee: 1,
        validateStatusChange: 2,
        validateBfiNumbers: 3,
        validateMaturityDate: 4,
        checkHasChanges: 5,
        save: 6,
    };

    const loadBfiEmployees = async () => {
        const data = await listApi.getBfiEmployees();
        set_employees(data);
    };

    const loadBrokerFeeTypes = async () => {
        const data = await listApi.getBrokerFeeTypes();
        set_brokerFeeTypes([{ key: null, name: null }, ...data]);
    };

    const loadInterestTypes = async () => {
        const data = await listApi.getLoanInterestTypes();
        set_interestTypes(data);
    };

    const loadInterestPaymentDueTypes = async () => {
        const data = await listApi.getLoanInterestPaymentDueTypes();
        set_interestpaymentDueTypes([{ key: null, name: null }, ...data]);
    };

    const validateBfiNumbers = async (event, force) => {
        if (!bfiNumber && !loanNumber) {
            set_checkNumbers(null);
            set_isBfiNumberValid(true);
            set_isLoanNumberValid(true);
            return true;
        }

        var newChecks = (bfiNumber ?? '') + (loanNumber ?? '');
        if (!force && !isBfiNumberValid && checkNumbers === newChecks) {
            return;
        }
        set_checkNumbers(newChecks);

        if (loanNumber && !bfiNumber) {
            //Can't have a loan number without a BFI Number
            set_isBfiNumberValid(false);
            set_informModalMessage('A Loan # requires that a BFI Number is also entered.');
            set_informModalOpen(true);
            return false;
        }

        const model = {
            id: loan?.id ?? 0,
            bfiNumber,
            loanNumber,
            borrowerEntityId,
            brokerAgreementId,
        };

        const result = (await loanApi.masterNoteValidate(model)).result;
        let msg = result.message;
        set_isBfiNumberValid(result.bfiNumberValid);
        set_isLoanNumberValid(result.loanNumberValid);
        if (result.isValid) {
            if (msg) {
                set_loadingOpen(false);
                msg += ' Do you wish to continue?';
                set_confirmNumbersModalText(msg);
                set_confirmNumbersModalOpen(true);
                return false;
            }
        } else {
            set_loadingOpen(false);
            set_informModalMessage(msg);
            set_informModalOpen(true);
            return false;
        }
        return true;
    };

    const validateSubmission = async (e, step) => {
        if (e) {
            e.preventDefault();
        }
        step = step ?? saveStages.validateSbaFee;

        if (step === saveStages.validateSbaFee) {
            if (sbaUpfrontFee - borrowerCharge < 0) {
                set_informModalMessage("'SBA Upfront Fee' must be larger than 'Charged Borrower'");
                set_informModalOpen(true);
                return false;
            }
            step = saveStages.validateStatusChange;
        }

        set_loadingMessage('Validating...');
        set_loadingOpen(true);

        //Check if in Approved State and user entered a NoteDate
        if (step === saveStages.validateStatusChange) {
            if (statusId === LoanStatusType.Approved && noteDate) {
                set_loadingOpen(false);
                set_confirmMoveToOutstandingModalText(
                    'Setting the Note Date will cause the loan to move to Outstanding (Closed) status. Are you sure?'
                );
                set_confirmMoveToOutstandingModalOpen(true);
                return false;
            }
            step = saveStages.validateBfiNumbers;
        }

        //Check Loan and BfiNumbers to ensure they are unique
        if (step === saveStages.validateBfiNumbers) {
            const areNumbersOk = await validateBfiNumbers(null, true);
            if (!areNumbersOk) {
                set_loadingOpen(false);
                return false;
            }
            step = saveStages.validateMaturityDate;
        }

        //Alert if the Maturity Date is potentially wrong
        if (step === saveStages.validateMaturityDate) {
            if (maturityDateWarning) {
                //alert and continue if confirmed
                set_loadingOpen(false);
                set_confirmMaturityDateModalText(maturityDateWarningText);
                set_confirmMaturityDateModalOpen(true);
                return false;
            }
            step = saveStages.checkHasChanges;
        }

        const hasChanges = hasOutandingLoanChanges();
        if (hasChanges) {
            //Display modal and allow user to enters reason for change
            set_changesModalOpen(true);
            set_loadingOpen(false);
            return;
        } else {
            step = saveStages.save;
        }

        if (step === saveStages.save) {
            await saveLoan();
        }
    };

    const getModel = () => {
        return {
            id: loan?.id,
            statusId,
            approvalDate: approvalDate ? new Date(approvalDate).toLocaleDateString('en-us') : null,
            bfiNumber,
            loanNumber,
            commitment: commitment,
            noteDate: noteDate ? new Date(noteDate).toLocaleDateString('en-us') : null,
            initialTermMonths,
            contractualExtension1Months,
            contractualExtension2Months,
            maturityDate: maturityDate ? new Date(maturityDate).toLocaleDateString('en-us') : null,
            plannedClosingDate: plannedClosingDate ? new Date(plannedClosingDate).toLocaleDateString('en-us') : null,
            interestTypeId,
            interestRate,
            reserveRate,
            loanGradeType: loanGradeType || null,
            brokerFee,
            brokerAgreementId,
            borrowerEntityId: borrowerEntityId,
            brokerId: brokerId,
            brokerFeeTypeId,
            brokerFeeName,
            brokerFootnote,
            sbaGuarantyPercent,
            pointOfContactId,
            sbaUpfrontFee,
            borrowerCharge,
            recurringSbaFeePercent,
            interestPaymentDueTypeId,
            dueDate1,
            dueDate2,
            dueDate3,
            dueDate4,
            insuranceGroup: showInsurance ? insuranceGroup : null,
            repaidDate: repaidDate ? new Date(repaidDate).toLocaleDateString('en-us') : null,
            repaidReason,
        };
    };

    const saveLoan = async (changesModel) => {
        try {
            set_loadingMessage('Saving...');
            set_loadingOpen(true);

            //Save main
            set_loadingMessage('Saving MasterNote changes...');

            const model = getModel();
            model.changeSummary = changesModel;

            const response = await loanApi.masterNoteSave(model);
            if (response.statusCode !== 200) {
                set_loadingOpen(false);
                return;
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Master Note Saved successfully.');

            setTimeout(() => {
                handleClose();
            }, 600);
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    const confirmNumber_confirm = async () => {
        set_confirmNumbersModalOpen(false);
        await validateSubmission(null, saveStages.validateMaturityDate);
    };

    const confirmNumber_cancel = () => {
        set_confirmNumbersModalOpen(false);
        set_loadingOpen(false);
    };

    const confirmMoveToOutstanding_confirm = async () => {
        set_confirmMoveToOutstandingModalOpen(false);
        await validateSubmission(null, saveStages.validateBfiNumbers);
    };

    const confirmMoveToOutstanding_cancel = async () => {
        set_confirmMoveToOutstandingModalOpen(false);
        set_loadingOpen(false);
    };

    const confirmMaturityDate_confirm = async () => {
        set_confirmMaturityDateModalOpen(false);
        await validateSubmission(null, saveStages.checkHasChanges);
    };

    const confirmMaturityDate_cancel = () => {
        set_confirmMaturityDateModalOpen(false);
        set_confirmMaturityDateModalText('');
        set_loadingOpen(false);
    };

    const resetState = () => {
        set_currentLoanId(0);
        set_bClientOrEntity(BClientOrEntitySelectorType.Entity);
        set_loan(null);
        set_statusId(0);
        set_approvalDate(null);
        set_bfiNumber('');
        set_loanNumber('');
        set_commitment('');
        set_noteDate(null);
        set_selectedTermKey('');
        set_initialTermMonths(null);
        set_contractualExtension1Months(null);
        set_contractualExtension2Months(null);
        set_maturityDate(null);
        set_plannedClosingDate(null);
        set_interestTypeId(0);
        set_interestRate('');
        set_reserveRate('');
        set_loanGradeType('');
        set_brokerFee('');
        set_pointOfContactId('');
        set_borrowerEntityId('');
        set_brokerAgreementId('');
        set_brokerAgreementLocked(false);
        set_brokerId('');
        set_brokerFeeTypeId('');
        set_brokerFeeName('');
        set_brokerFootnote('');
        set_sbaGuarantyPercent('');
        set_sbaUpfrontFee('');
        set_borrowerCharge('');
        set_recurringSbaFeePercent('');
        set_interestPaymentDueTypeId('');
        set_dueDate1('');
        set_dueDate2('');
        set_dueDate3('');
        set_dueDate4('');
        setInsuranceGroup(emptyInsuranceGroup);
        set_repaidDate('');
        set_repaidReason('');
    };

    const getDays = () => {
        const returnVal = [];
        for (let x = 1; x <= 31; x++) {
            returnVal.push({ id: x, name: x.toString().padStart(2, '0') });
        }
        return returnVal;
    };

    const onInformModalConfirm = () => {
        set_informModalOpen(false);
    };

    const setInsuranceGroup = (insGroup) => {
        insGroup = insGroup ?? emptyInsuranceGroup;
        insGroup.loanTypeId = LoanType.MasterNote;
        insGroup.insurances = setInsurancesForLoanType(insGroup.insurances, LoanType.MasterNote, false);
        set_insuranceGroup({ ...insGroup });
    };

    const hasOutandingLoanChanges = () => {
        if (loan.statusId !== LoanStatusType.Outstanding) {
            return false;
        }

        //Fields of Interest
        //Setup: Approval date, Note date, Term, Maturity date, BFI #, Loan #,
        //Loan: Commitment, Interest rate, Interest Accrual, interestRateFloor, interestRateCeiling, Reserve Rate, Underwriting Fee,
        let hasChanges = false;

        if (loan.approvalDate) {
            hasChanges = new Date(loan.approvalDate).toLocaleDateString('en-us') !== approvalDate?.toLocaleDateString('en-us');
        }
        if (hasChanges) {
            return true;
        }

        if (loan.noteDate) {
            hasChanges = new Date(loan.noteDate).toLocaleDateString('en-us') !== noteDate?.toLocaleDateString('en-us');
        }
        if (hasChanges) {
            return true;
        }

        if (loan.maturityDate) {
            hasChanges = new Date(loan.maturityDate).toLocaleDateString('en-us') !== maturityDate?.toLocaleDateString('en-us');
        }
        if (hasChanges) {
            return true;
        }

        hasChanges =
            loan.initialTermMonths !== initialTermMonths ||
            loan.contractualExtension1Months !== contractualExtension1Months ||
            loan.contractualExtension2Months !== contractualExtension2Months ||
            loan.bfiNumber !== bfiNumber ||
            loan.loanNumber !== loanNumber ||
            loan.commitment !== commitment ||
            loan.interestTypeId !== interestTypeId ||
            loan.interestRate !== interestRate ||
            loan.reserveRate !== reserveRate ||
            //SBA Guarantee
            loan.sbaGuarantyPercent !== sbaGuarantyPercent ||
            loan.sbaUpfrontFee !== sbaUpfrontFee ||
            loan.borrowerCharge !== borrowerCharge ||
            loan.recurringSbaFeePercent !== recurringSbaFeePercent ||
            //Payment dates
            loan.interestPaymentDueTypeId !== interestPaymentDueTypeId ||
            loan.dueDate1 !== dueDate1 ||
            loan.dueDate2 !== dueDate2 ||
            loan.dueDate3 !== dueDate3 ||
            loan.dueDate4 !== dueDate4;

        if (hasChanges) {
            return true;
        }

        return hasChanges;
    };

    useEffect(() => {
        async function loadData() {
            await loadBfiEmployees();
            await loadBrokerFeeTypes();
            await loadInterestTypes();
            await loadInterestPaymentDueTypes();
        }

        loadData();
    }, []);

    useEffect(() => {
        async function onIsOpenChange() {
            if (!isOpen) {
                return;
            }

            resetState();
            set_isBfiNumberValid(true);
            set_isLoanNumberValid(true);
            set_checkNumbers(null);
            if (loanId && loanId > 0) {
                await loadFromLoanId(loanId);
            } else {
                set_loan({});
            }
            set_loadingOpen(false);
        }

        onIsOpenChange();
    }, [isOpen, loanId]);

    const onInterestPaymentDueTypeChange = (interestPaymentDueType) => {
        set_interestPaymentDueTypeId(interestPaymentDueType);
        switch (interestPaymentDueType) {
            case 1: //Quarterly
            case 2: //Semi-Annually
                set_interestPaymentStartingMonth('');
                set_dueDate1(null);
                set_dueDate2(null);
                set_dueDate3(null);
                set_dueDate4(null);
                break;
            default:
                //Monthly
                set_dueDate1('01');
                set_dueDate2(null);
                set_dueDate3(null);
                set_dueDate4(null);
                set_interestPaymentStartingMonth('');
                break;
        }
    };

    const onInterestPaymentStartingMonth = (startingMonth, interestPaymentDueType) => {
        set_interestPaymentStartingMonth(startingMonth);

        // Build the new schedule directly
        const currentSchedule = buildPaymentSchedule(interestPaymentDueType, startingMonth);

        switch (interestPaymentDueType) {
            case 1: // Quarterly
                set_dueDate1(currentSchedule[0].scheduleDate);
                set_dueDate2(currentSchedule[1].scheduleDate);
                set_dueDate3(currentSchedule[2].scheduleDate);
                set_dueDate4(currentSchedule[3].scheduleDate);
                break;

            case 2: // Semi-Annually
                set_dueDate1(currentSchedule[0].scheduleDate);
                set_dueDate2(currentSchedule[1].scheduleDate);
                set_dueDate3(null);
                set_dueDate4(null);
                break;

            default:
                break;
        }
    };

    useEffect(() => {
        if (!noteDate) {
            return;
        }
        if (initialTermMonths) {
            //If the number of months is approximately correct then don't update the maturity date
            var months = monthDiff(noteDate, maturityDate);
            if (months !== initialTermMonths) {
                const dt = new Date(noteDate.getTime());
                if (!maturityDate) {
                    set_maturityDate(addMonths(dt, initialTermMonths));
                } else {
                    set_maturityDateWarning(true);
                    if (months > initialTermMonths) {
                        set_maturityDateWarningText('Maturity Date Is Past the Loan Terms.');
                    } else {
                        set_maturityDateWarningText('Maturity Date Is Less than the Loan Terms.');
                    }
                }
            } else {
                set_maturityDateWarning(false);
                set_maturityDateWarningText('');
            }
        }
    }, [noteDate, initialTermMonths, maturityDate]);

    const onBClientOrEntitySelection = (selectionType, id) => {
        set_bClientOrEntity(selectionType);
        if (selectionType === BClientOrEntitySelectorType.BClient) {
            set_brokerAgreementId(id);
            return;
        }

        set_borrowerEntityId(id);
        if (selectionType === BClientOrEntitySelectorType.Entity) {
            set_brokerAgreementId(null);
        }
    };

    const onBrokerSelect = (broker) => {
        if (brokerAgreementId || !broker) {
            set_brokerId(null);
            return;
        }

        set_brokerId(broker.id);
    };

    const loadFromLoanId = async (loanId) => {
        try {
            set_loadingMessage('Loading...');
            set_loadingOpen(true);

            resetState();
            const response = await loanApi.masterNoteGetById(loanId);
            if (response.statusCode !== 200) {
                return;
            }
            const loan = response.result;
            populateState(loan);
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    const populateState = (loan) => {
        if (!loan) {
            resetState();
            return;
        }

        set_currentLoanId(loan.id);

        const clone = JSON.parse(JSON.stringify(loan));
        set_loan(clone);

        set_statusId(loan.statusId);
        set_bfiNumber(loan.bfiNumber);
        set_loanNumber(loan.loanNumber ?? '');
        set_commitment(loan.commitment);
        set_pointOfContactId(loan.pointOfContactId);

        set_borrowerEntityId(loan.borrowerEntityId);
        set_brokerId(loan.brokerId);
        if (loan.brokerAgreementId) {
            set_bClientOrEntity(BClientOrEntitySelectorType.BClient);
            set_brokerAgreementId(loan.brokerAgreementId);
        } else {
            set_bClientOrEntity(BClientOrEntitySelectorType.Entity);
        }

        if (loan.approvalDate) {
            set_approvalDate(new Date(loan.approvalDate));
        }
        if (loan.noteDate) {
            set_noteDate(new Date(loan.noteDate));
        }
        // Set term values
        set_initialTermMonths(loan.initialTermMonths);
        set_contractualExtension1Months(loan.contractualExtension1Months);
        set_contractualExtension2Months(loan.contractualExtension2Months);
        // Determine which dropdown option matches the loan's term values
        const termKey = findMatchingTermOptionKey(
            LoanType.MasterNote,
            loan.initialTermMonths,
            loan.contractualExtension1Months,
            loan.contractualExtension2Months
        );
        set_selectedTermKey(termKey);
        if (loan.maturityDate) {
            set_maturityDate(new Date(loan.maturityDate));
        }
        if (loan.plannedClosingDate) {
            set_plannedClosingDate(new Date(loan.plannedClosingDate));
        }

        set_brokerFeeTypeId(loan.brokerFeeTypeId);
        set_brokerFeeName(loan.brokerFeeName);
        set_interestTypeId(loan.interestTypeId);
        set_interestRate(loan.interestRate);
        set_reserveRate(loan.reserveRate);
        set_loanGradeType(loan.loanGradeType ?? '');
        set_brokerFee(loan.brokerFee ?? '');
        set_sbaGuarantyPercent(loan.sbaGuarantyPercent);
        set_sbaUpfrontFee(loan.sbaUpfrontFee);
        set_borrowerCharge(loan.borrowerCharge);
        set_recurringSbaFeePercent(loan.recurringSbaFeePercent);
        onInterestPaymentDueTypeChange(loan.interestPaymentDueTypeId);
        if (loan.dueDate1 != '01') {
            const monthId = loan.dueDate1.split('/')[1];
            onInterestPaymentStartingMonth(monthId, loan.interestPaymentDueTypeId);
        }
        set_insuranceGroup(loan.insuranceGroup ?? emptyInsuranceGroup);

        if (loan.brokerId) {
            set_brokerFeeTypeId(loan.brokerFeeTypeId);
            set_brokerFeeName(loan.brokerFeeTypeId === 0 ? loan.brokerFeeName : null);
            set_brokerFootnote(loan.brokerFootnote);
        } else {
            set_brokerFeeTypeId(null);
            set_brokerFeeName(null);
            set_brokerFootnote(null);
        }

        setInsuranceGroup(loan.insuranceGroup);

        if (loan.statusId === LoanStatusType.Repaid && loan.repaidDate) {
            set_repaidDate(loan.repaidDate);
            set_repaidReason(loan.repaidReason);
        }
    };

    const onInsuranceChange = (insGroup) => {
        set_insuranceGroup({ ...insGroup });
    };

    const onChangesModalCancel = () => {
        set_changesModalOpen(false);
    };

    const onChangesModalSubmit = async (model) => {
        set_changesModalOpen(false);
        await saveLoan(model);
    };

    if (!loan) {
        return null;
    }

    return (
        <div className='loan'>
            <Dialog
                maxWidth='md'
                open={isOpen}
                onClose={handleClose}
                aria-labelledby='form-dialog-title'
            >
                <div className='modal-container'>
                    <div className='modal-backdrop'></div>
                    <div
                        className='modal'
                        tabIndex='-1'
                        role='dialog'
                        style={{ width: '1100px', overflow: 'unset' }}
                    >
                        <div
                            className='modal-dialog'
                            role='document'
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>
                                    {currentLoanId > 0 ? 'Update Master Note' : 'Add Master Note'}
                                    &nbsp;-{' '}
                                    {statusId === LoanStatusType.Approved && noteDate
                                        ? getStatusTypeName(LoanStatusType.Outstanding)
                                        : getStatusTypeName(statusId)}
                                </h1>
                                {/* <div style={styles.headerRight}>
                                        <button
                                            type="button"
                                            className="button hollow"
                                            style={{ backgroundColor: 'white' }}
                                            onClick={() => alert('ToDo')}
                                        >
                                            Import
                                        </button>
                                </div> */}
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={handleClose}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                        </div>
                        <div
                            className='main-content no-search'
                            style={{ padding: '0', width: '100%' }}
                        >
                            <form
                                name='addEditLoanForm'
                                onSubmit={(event) => validateSubmission(event, saveStages.validateSbaFee)}
                                className={'standard-form'}
                            >
                                <div
                                    className='scrollable-content'
                                    style={{ padding: '0px 60px 0 20px' }}
                                >
                                    <div
                                        style={{
                                            float: 'right',
                                            marginTop: '10px',
                                            cursor: 'pointer',
                                        }}
                                        id='instructions'
                                        onMouseEnter={(e) => set_instructionsToolTipVisible(true)}
                                        onMouseLeave={(e) => set_instructionsToolTipVisible(false)}
                                    >
                                        <b>Required Fields</b>&nbsp;
                                        <FontAwesomeIcon icon={faQuestionCircle} />
                                    </div>
                                    <h2
                                        className='decorated'
                                        style={styles.sectionHeader}
                                    >
                                        Setup
                                    </h2>
                                    <div className='row'>
                                        <LoanTermFields
                                            loanTypeId={LoanType.MasterNote}
                                            selectedTermKey={selectedTermKey}
                                            set_selectedTermKey={set_selectedTermKey}
                                            initialTermMonths={initialTermMonths}
                                            set_initialTermMonths={set_initialTermMonths}
                                            contractualExtension1Months={contractualExtension1Months}
                                            set_contractualExtension1Months={set_contractualExtension1Months}
                                            contractualExtension2Months={contractualExtension2Months}
                                            set_contractualExtension2Months={set_contractualExtension2Months}
                                            noteDate={noteDate}
                                        />
                                    </div>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='approvalDate'>
                                                BFI Approval {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <DateBox
                                                id='approvalDate'
                                                value={approvalDate}
                                                onValueChange={set_approvalDate}
                                                required={noteDate}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='noteDate'>
                                                Note Date{' '}
                                                {(statusId === LoanStatusType.Outstanding ||
                                                    statusId === LoanStatusType.Repaid) && <span className='req'>*</span>}
                                            </label>
                                            <DateBox
                                                id='noteDate'
                                                value={noteDate}
                                                onValueChange={set_noteDate}
                                                required={
                                                    statusId === LoanStatusType.Outstanding || statusId === LoanStatusType.Repaid
                                                }
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='maturityDate'>
                                                Maturity Date
                                                {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <DateBox
                                                id='maturityDate'
                                                value={maturityDate}
                                                onValueChange={set_maturityDate}
                                                required={noteDate}
                                            />
                                            {maturityDateWarning && (
                                                <div style={styles.warning}>
                                                    <span className='helper'>
                                                        <span className='tooltip-trigger'>
                                                            <FontAwesomeIcon
                                                                style={{ color: 'red' }}
                                                                icon={faExclamationTriangle}
                                                            />
                                                        </span>
                                                        <span className='text'>{maturityDateWarningText}</span>
                                                    </span>
                                                    &nbsp;Date Warning!
                                                </div>
                                            )}
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='plannedClosingDate'>Planned Closing</label>
                                            <DateBox
                                                id='plannedClosingDate'
                                                value={plannedClosingDate}
                                                onValueChange={set_plannedClosingDate}
                                                required={false}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='bfiNumber'>BFI # {noteDate && <span className='req'>*</span>}</label>
                                            <BfiNumber
                                                id={'bfiNumber'}
                                                onChange={set_bfiNumber}
                                                value={bfiNumber}
                                                required={noteDate}
                                                isValid={isBfiNumberValid}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='loanNumber'>
                                                Loan # {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <LoanNumber
                                                id={'loanNumber'}
                                                onChange={set_loanNumber}
                                                value={loanNumber}
                                                required={noteDate}
                                                isValid={isLoanNumberValid}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-4'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='pointOfContactId'>
                                                POC {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <select
                                                id='pointOfContactId'
                                                value={pointOfContactId}
                                                onChange={(event) => set_pointOfContactId(event.target.value)}
                                                required={noteDate}
                                            >
                                                <option value=''></option>
                                                {employees &&
                                                    employees.map((poc) => {
                                                        return (
                                                            <option
                                                                key={poc.key}
                                                                value={poc.key}
                                                            >
                                                                {poc.name}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div>
                                    {loan.statusId === LoanStatusType.Repaid && (
                                        <div className='row'>
                                            <div
                                                className='columns small-12 large-2'
                                                style={styles.formColumn}
                                            >
                                                <label htmlFor='repaidDate'>
                                                    Termination Date <span className='req'>*</span>
                                                </label>
                                                <DateBox
                                                    id='repaidDate'
                                                    value={repaidDate}
                                                    onValueChange={set_repaidDate}
                                                    required={true}
                                                />
                                            </div>
                                            <div
                                                className='columns small-12 large-12'
                                                style={styles.formColumn}
                                            >
                                                <label htmlFor='notes'>
                                                    Termination Notes
                                                    <span className='req'>*</span>
                                                </label>
                                                <textarea
                                                    style={{ width: '100%' }}
                                                    rows={3}
                                                    id='repaidReason'
                                                    value={repaidReason}
                                                    onChange={(e) => set_repaidReason(e.target.value)}
                                                    required={true}
                                                    placeholder='Enter further description and explanation notes...'
                                                    maxLength={1000}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <h2
                                        className='decorated'
                                        style={styles.sectionHeader}
                                    >
                                        Borrower
                                    </h2>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-12'
                                            style={styles.formColumn}
                                        >
                                            <BClientOrEntitySelector
                                                borrowerEntityId={borrowerEntityId}
                                                brokerAgreementId={brokerAgreementId}
                                                onSelect={onBClientOrEntitySelection}
                                                disabled={brokerAgreementLocked}
                                            />
                                            {bClientOrEntity === BClientOrEntitySelectorType.Entity && (
                                                <BrokerSelect
                                                    brokerId={brokerId}
                                                    onSelect={onBrokerSelect}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    {brokerId && brokerId > 0 && (
                                        <div className='row'>
                                            <div
                                                className='columns small-12 large-5 type-ahead-container'
                                                style={styles.formColumn}
                                            >
                                                <label htmlFor='brokerFeeTypeId'>
                                                    Fee {noteDate && <span className='req'>*</span>}
                                                </label>
                                                <select
                                                    id='brokerFeeTypeId'
                                                    value={brokerFeeTypeId}
                                                    onChange={(event) => set_brokerFeeTypeId(parseInt(event.target.value))}
                                                    required={noteDate}
                                                >
                                                    {brokerFeeTypes.map((fs) => {
                                                        return (
                                                            <option
                                                                key={fs.key}
                                                                value={fs.key}
                                                            >
                                                                {fs.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            {brokerFeeTypeId === 0 && (
                                                <div
                                                    className='columns small-12 large-5'
                                                    style={styles.formColumn}
                                                >
                                                    <label htmlFor='brokerFeeName'>
                                                        Fee Name
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <input
                                                        type='text'
                                                        id={brokerFeeName}
                                                        value={brokerFeeName}
                                                        maxLength='100'
                                                        onChange={(event) => set_brokerFeeName(event.target.value)}
                                                        placeholder='Enter Fee name...'
                                                        required={true}
                                                    />
                                                </div>
                                            )}
                                            <div
                                                className='columns small-12 large-12'
                                                style={styles.formColumn}
                                            >
                                                <label htmlFor='brokerFootnote'>Footnote</label>
                                                <input
                                                    type='text'
                                                    id={brokerFootnote}
                                                    value={brokerFootnote}
                                                    maxLength='100'
                                                    onChange={(event) => set_brokerFootnote(event.target.value)}
                                                    placeholder='Enter footnote...'
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <h2
                                        className='decorated'
                                        style={styles.sectionHeader}
                                    >
                                        Loan
                                    </h2>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='commitment'>
                                                Total Credit Line {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='commitment'
                                                onValueChange={(values) => {
                                                    set_commitment(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                prefix={'$'}
                                                value={commitment}
                                                displayType='input'
                                                thousandSeparator={','}
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='column small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='interestTypeId'>
                                                Interest Type <span className='req'>*</span>
                                            </label>
                                            <select
                                                id='interestTypeId'
                                                value={interestTypeId}
                                                onChange={(event) => set_interestTypeId(parseInt(event.target.value))}
                                                required={true}
                                            >
                                                {interestTypes.map((fs) => {
                                                    return (
                                                        <option
                                                            key={fs.key}
                                                            value={fs.key}
                                                        >
                                                            {fs.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='interestRate'>
                                                {interestTypeId === 0 ? 'Interest Rate' : 'Sprd over Prime'}
                                                {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='interestRate'
                                                onValueChange={(values) => {
                                                    set_interestRate(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                suffix={'%'}
                                                placeholder='%'
                                                value={interestRate}
                                                displayType='input'
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='reserveRate'>
                                                Reserve Rate {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='reserveRate'
                                                onValueChange={(values) => {
                                                    set_reserveRate(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                suffix={'%'}
                                                placeholder='%'
                                                value={reserveRate}
                                                displayType='input'
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='loanGradeType'>Grade</label>
                                            <select
                                                id='loanGradeType'
                                                value={loanGradeType ?? ''}
                                                onChange={(event) => {
                                                    const v = event.target.value;
                                                    set_loanGradeType(v === '' ? '' : parseInt(v));
                                                }}
                                            >
                                                <option value=''></option>
                                                {LoanGradeTypeOptions.filter((x) => x.isLoc === true).map((o) => {
                                                    return (
                                                        <option
                                                            key={o.id}
                                                            value={o.id}
                                                        >
                                                            {o.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='brokerFee'>Broker Fee</label>
                                            <NumericFormat
                                                id='brokerFee'
                                                thousandSeparator=','
                                                prefix={'$'}
                                                placeholder='$'
                                                value={brokerFee}
                                                decimalScale={2}
                                                allowNegative={false}
                                                onValueChange={(values) => {
                                                    set_brokerFee(values.floatValue);
                                                }}
                                                displayType='input'
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value >= 0;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h2
                                        className='decorated'
                                        style={styles.sectionHeader}
                                    >
                                        SBA Guarantee
                                    </h2>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label
                                                htmlFor='sbaGuarantyPercent'
                                                style={{ paddingRight: '10px' }}
                                            >
                                                SBA Guarantee % {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='sbaGuarantyPercent'
                                                onValueChange={(values) => {
                                                    set_sbaGuarantyPercent(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                suffix={'%'}
                                                placeholder='%'
                                                value={sbaGuarantyPercent}
                                                displayType='input'
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label
                                                htmlFor='sbaUpfrontFee'
                                                style={{ paddingRight: '10px' }}
                                            >
                                                SBA Upfront Fee {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='sbaUpfrontFee'
                                                thousandSeparator=','
                                                onValueChange={(values) => {
                                                    set_sbaUpfrontFee(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                placeholder='$'
                                                prefix={'$'}
                                                value={sbaUpfrontFee}
                                                displayType='input'
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value >= 0;
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-1'
                                            style={styles.mathOperation}
                                        >
                                            -
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label
                                                htmlFor='borrowerCharge'
                                                style={{ paddingRight: '10px' }}
                                            >
                                                Charged Borrower {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='sbaUpfrontFee'
                                                onValueChange={(values) => {
                                                    set_borrowerCharge(values.floatValue);
                                                }}
                                                required={noteDate}
                                                decimalScale={2}
                                                allowNegative={false}
                                                prefix={'$'}
                                                placeholder='$'
                                                value={borrowerCharge}
                                                displayType='input'
                                                thousandSeparator={','}
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value >= 0;
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='columns small-12 large-1'
                                            style={styles.mathOperation}
                                        >
                                            =
                                        </div>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='borrowerCharge'>Paid by BFI</label>
                                            <NumericFormat
                                                id='paidByBfi'
                                                disabled={true}
                                                decimalScale={2}
                                                allowNegative={false}
                                                prefix={'$'}
                                                value={sbaUpfrontFee - borrowerCharge}
                                                displayType='input'
                                                thousandSeparator={','}
                                                className={sbaUpfrontFee - borrowerCharge < 0 ? 'red' : ''}
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value > 0;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div
                                            className='columns small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label
                                                htmlFor='recurringSbaFeePercent'
                                                style={{ paddingRight: '10px' }}
                                            >
                                                Recurring SBA Fee {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <NumericFormat
                                                id='recurringSbaFeePercent'
                                                onValueChange={(values) => {
                                                    set_recurringSbaFeePercent(values.floatValue);
                                                }}
                                                decimalScale={2}
                                                allowNegative={false}
                                                suffix={'%'}
                                                placeholder='%'
                                                value={recurringSbaFeePercent}
                                                displayType='input'
                                                required={noteDate}
                                                isAllowed={(values, sourceInfo) => {
                                                    const value = values?.floatValue;
                                                    return value === undefined || value === null || value >= 0;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h2
                                        className='decorated'
                                        style={styles.sectionHeader}
                                    >
                                        Interest Payment Due Dates
                                    </h2>
                                    <div className='row'>
                                        <div
                                            className='column small-12 large-2'
                                            style={styles.formColumn}
                                        >
                                            <label htmlFor='interestPaymentDueTypeId'>
                                                Interest Period {noteDate && <span className='req'>*</span>}
                                            </label>
                                            <select
                                                id='interestPaymentDueTypeId'
                                                value={interestPaymentDueTypeId}
                                                onChange={(event) => onInterestPaymentDueTypeChange(parseInt(event.target.value))}
                                                required={noteDate}
                                            >
                                                {interestpaymentDueTypes.map((fs) => {
                                                    return (
                                                        <option
                                                            key={fs.key}
                                                            value={fs.key}
                                                        >
                                                            {fs.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        {(interestPaymentDueTypeId === 1 || interestPaymentDueTypeId === 2) && (
                                            <div
                                                className='column small-12 large-2'
                                                style={styles.formColumn}
                                            >
                                                <label htmlFor='interestPaymentStartingMonth'>
                                                    Starting Month <span className='req'>*</span>
                                                </label>
                                                <select
                                                    id='interestPaymentStartingMonth'
                                                    value={interestPaymentStartingMonth}
                                                    onChange={(event) =>
                                                        onInterestPaymentStartingMonth(
                                                            event.target.value,
                                                            interestPaymentDueTypeId
                                                        )
                                                    }
                                                    required={interestPaymentDueTypeId === 1 || interestPaymentDueTypeId === 2}
                                                >
                                                    {MonthTypeOptions.map((fs) => {
                                                        return (
                                                            <option
                                                                key={fs.id}
                                                                value={fs.id}
                                                            >
                                                                {fs.name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        )}
                                        <div className={`column small-12 large-${interestPaymentDueTypeId !== 0 ? '4' : '5'}`}>
                                            {schedule.length > 0 &&
                                                (interestPaymentDueTypeId === 0 ||
                                                    ((interestPaymentDueTypeId === 1 || interestPaymentDueTypeId === 2) &&
                                                        interestPaymentStartingMonth !== '')) && (
                                                    <div style={{ paddingLeft: '2rem' }}>
                                                        <h5 style={{ marginBottom: '0.25rem' }}>Payment Schedule</h5>

                                                        {/* Separator directly under the header */}
                                                        <div
                                                            style={{
                                                                height: '2px',
                                                                backgroundColor: '#ccc',
                                                                marginBottom: '0.25rem',
                                                            }}
                                                        />

                                                        {interestPaymentDueTypeId === 0 ? (
                                                            <div>Payment Due the first of every month.</div>
                                                        ) : (
                                                            <table
                                                                style={{
                                                                    width: 'auto',
                                                                    borderCollapse: 'collapse',
                                                                }}
                                                            >
                                                                <tbody>
                                                                    {schedule.map((p, index) => (
                                                                        <tr key={index}>
                                                                            <td
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    paddingRight: '0.75rem',
                                                                                    fontWeight: 'bold',
                                                                                }}
                                                                            >
                                                                                Due:
                                                                            </td>
                                                                            <td style={{ whiteSpace: 'nowrap' }}>{p.label}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        )}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                    {showInsurance && (
                                        <>
                                            <h2
                                                className='decorated'
                                                style={styles.sectionHeader}
                                            >
                                                Coverage
                                            </h2>
                                            <InsuranceGrid
                                                insuranceGroup={insuranceGroup}
                                                onChange={onInsuranceChange}
                                                enabled={true}
                                            />
                                        </>
                                    )}
                                </div>
                                <div
                                    className='button-footer'
                                    style={styles.buttonContainer}
                                >
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='submit'
                                        className='button primary'
                                        title='Save all changes'
                                    >
                                        Save
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        data-dismiss='modal'
                                        onClick={handleClose}
                                        title='Abandon changes and close this window'
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Dialog>
            <ConfirmModal
                isOpen={confirmNumbersModalOpen}
                text={confirmNumbersModalText}
                confirmCallback={confirmNumber_confirm}
                cancelCallback={confirmNumber_cancel}
            />
            <ConfirmModal
                isOpen={confirmMoveToOutstandingModalOpen}
                text={confirmMoveToOutstandingModalText}
                confirmCallback={confirmMoveToOutstanding_confirm}
                cancelCallback={confirmMoveToOutstanding_cancel}
            />
            <ConfirmModal
                isOpen={confirmMaturityDateModalOpen}
                text={confirmMaturityDateModalText}
                confirmCallback={confirmMaturityDate_confirm}
                cancelCallback={confirmMaturityDate_cancel}
                confirmButtonText='Continue'
                cancelButtonText='Cancel'
            />
            <InformModal
                isOpen={informModalOpen}
                text={informModalMessage}
                confirmCallback={onInformModalConfirm}
            />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
            <Tooltip
                target={'#instructions'}
                visible={instructionsToolTipVisible}
                hideOnOutsideClick={false}
            >
                <div style={{ width: '500px', textAlign: 'left' }}>
                    <div
                        style={{
                            width: '100%',
                            margin: '5px 0',
                            whiteSpace: 'break-spaces',
                        }}
                    >
                        In the <b>Approved</b> stage, all fields are optional except 'Borrower'. After 'Note Date' is completed
                        (which automatically moves the Master Note to <b>Outstanding</b>) then the following fields are required:
                    </div>
                    <div style={{ width: '30%', float: 'left' }}>
                        <b>Setup</b>
                        <ul>
                            <li>BFI Approval</li>
                            <li>Note Date</li>
                            <li>Terms</li>
                            <li>Maturity Date</li>
                            <li>BFI #</li>
                            <li>Loan #</li>
                            <li>POC</li>
                        </ul>
                    </div>
                    <div style={{ width: '30%', float: 'left' }}>
                        <b>Loan</b>
                        <ul>
                            <li>Total Credit Line</li>
                            <li>Interest Rate</li>
                            <li>Reserve Rate</li>
                        </ul>
                    </div>
                    <div style={{ width: '30%', float: 'left' }}>
                        <b>SBA Guarantee</b>
                        <ul>
                            <li>SBA Guarantee %</li>
                            <li>SBA Upfront Fee</li>
                            <li>Charged Borrower</li>
                            <li>Recurring SBA Fee</li>
                        </ul>
                    </div>
                </div>
            </Tooltip>
            <LoanChangeReasonModal
                isOpen={changesModalOpen}
                onCancel={onChangesModalCancel}
                onSubmit={onChangesModalSubmit}
            />
        </div>
    );
};

export default EditMasterNoteModal;
